import { render, staticRenderFns } from "./ApplicantStudentExaminationRoom.vue?vue&type=template&id=cc56fad4&"
import script from "./ApplicantStudentExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./ApplicantStudentExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStudentExaminationRoom.vue?vue&type=style&index=0&id=cc56fad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports